import React from 'react';

const MoneyGraphicSvg = (props) => (
    <svg viewBox="0 0 144 144" {...props}>
        <g fill="none" fillRule="evenodd">
            <path fill="#FFF" d="M37.5 108.51h81V69.765h-81z" />
            <path
                d="M36 110h84.001V68.274H36V110zm3-2.981h77.999V71.255H39v35.764z"
                fill="#1E0A3C"
            />
            <path fill="#FFF" d="M31.5 102.549h81V63.804h-81z" />
            <path
                d="M30 104.039h84V62.314H30v41.725zm3-2.98h78V65.294H33v35.765z"
                fill="#1E0A3C"
            />
            <path fill="#DBDAE3" d="M25.5 96.588h81V57.843h-81z" />
            <path
                d="M24 98.078h84V56.353H24v41.725zm3-2.98h78V59.334H27v35.764z"
                fill="#1E0A3C"
            />
            <path
                fill="#F05537"
                d="M96 92.117H36l-6-5.962v-17.88l6-5.96h60l6 5.96v17.882z"
            />
            <path
                d="M76.5 77.216c0 5.76-4.701 10.432-10.5 10.432s-10.5-4.671-10.5-10.432S60.201 66.784 66 66.784s10.5 4.67 10.5 10.432"
                fill="#FFF"
            />
            <path
                d="M66 89.138c-6.617 0-12-5.35-12-11.922 0-6.573 5.383-11.922 12-11.922 6.616 0 12 5.349 12 11.922s-5.384 11.922-12 11.922m0-20.863c-4.963 0-9 4.009-9 8.94 0 4.932 4.037 8.943 9 8.943s9-4.011 9-8.942c0-4.932-4.037-8.941-9-8.941M43.5 78.706h3v-2.98h-3zM37.5 78.706h3v-2.98h-3zM91.5 78.706h3v-2.98h-3zM85.5 78.706h3v-2.98h-3zM58.5 53.99l-7.061-7.015 2.122-2.107 4.939 4.908 4.939-4.908 2.122 2.107zM85.5 53.99l-7.061-7.015 2.122-2.107 4.939 4.908 4.939-4.908 2.122 2.107z"
                fill="#1E0A3C"
            />
            <path
                fill="#1E0A3C"
                d="M60 51.882h-3V36.98H24V34h36zM87 51.882h-3V34h36v2.98H87z"
            />
        </g>
    </svg>
);

MoneyGraphicSvg.displayName = 'MoneyGraphicSvg';
export default MoneyGraphicSvg;
